export default __webpack_public_path__ + "static/media/pvilla2-2.816c10df.jpg";